module Visonum.BulkPingApp.Util
  ( dateTimeToStringISO8601
  , liftAffErr
  , liftEitherErr
  , padWith
  )
  where

import Prelude
import Data.String as Str
import Data.DateTime (DateTime(..))
import Data.DateTime as D
import Data.Enum (fromEnum)
import Control.Monad.Error.Class (class MonadError, liftEither)
import Data.Bifunctor (lmap)
import Data.Either (Either)
import Effect.Aff (Aff)
import Effect.Aff.Class (class MonadAff, liftAff)

padWith :: Int -> String -> String
padWith n str = pad (n - Str.length str) str

pad :: Int -> String -> String
pad 0 str = str
pad 1 str = "0" <> str
pad n str = pad (n - 1) ("0" <> str)

dateTimeToStringISO8601 :: DateTime -> String
dateTimeToStringISO8601 (DateTime date time) = encodeDate date <> "T" <> encodeTime time
  where
  encodeDate d =
    (padWith 4 $ show $ fromEnum $ D.year d)
      <> "-"
      <> (padWith 2 $ show $ fromEnum $ D.month d)
      <> "-"
      <> (padWith 2 $ show $ fromEnum $ D.day d)

  encodeTime t = (padWith 2 $ show $ fromEnum $ D.hour t)
    <> ":"
    <> (padWith 2 $ show $ fromEnum $ D.minute t)
    <> ":"
    <> (padWith 2 $ show $ fromEnum $ D.second t)
    <> "."
    <> (show $ fromEnum $ D.millisecond t)
    <> "Z"


liftAffErr :: forall e1 e2 m a. MonadError e2 m => MonadAff m => (e1 -> e2) -> Aff (Either e1 a) -> m a
liftAffErr mapErr io =
  map (lmap mapErr) io
    # liftAff
    >>= liftEither

liftEitherErr :: forall e2 e1 m a. (MonadError e2 m) => (e1 -> e2) -> Either e1 a -> m a
liftEitherErr mapErr = liftEither <<< lmap mapErr